import React from "react";
import {NavLink} from "react-router-dom";
import style from "../Dialogs.module.css";

const DialogItem = (props) => {
    let path = '/react/dialogs/' + "user"+ props.id;
    return (
        <div className={style.dialogsItem}>
            <div className={style.imgContainer}>
                <img src={props.avatar} alt="avatar"/>
            </div>
            <NavLink to={path}>{props.name}</NavLink>
        </div>
    )
}


export default DialogItem;








//
// const DialogItem = (props) => {
//     let path = 'dialogs/' + props.id
//     return(
//         <div className={style.dialogsItemContainer}>
//             <NavLink to={path} className={style.user}>
//                 <img src={props.avatar} alt="avatar"/>
//                 <p>{props.name}</p>
//             </NavLink>
//         </div>
//     )
// }